import Swal from 'sweetalert2'
import ProjectDetail from '../ProjectDetail/ProjectDetail'
import Loader from '../Loader/Loader'
import { getProject } from '../../services/firebase.js'
import { useState, useEffect } from 'react'
import { useParams, Navigate } from 'react-router-dom'

function ProjectDetailContainer() {
    const [project , setProject] = useState([])
    const [projectIsLoading , setProjectIsLoading] = useState(true)
    const { projectId } = useParams()
    const [ errorText, setErrorText ] = useState(null)

    useEffect(() => {
        async function requestProject(){
            setProjectIsLoading(true)
            try {
                const response = await getProject(projectId)
                setProject(response)
            } catch(error) {
                setErrorText(error.message)
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No pudimos encontrar ese proyecto',
                    showConfirmButton: false,
                    timer: 1500,
                    footer: ''
                    })
            } finally {
                setProjectIsLoading(false)
            }
        }
        requestProject()
    }, [projectId])

    if (projectIsLoading){
        return(
            <Loader />
        )
    }

    if (errorText) {
        return (
            <div>
                <Navigate to='/' />
            </div>
        )
    } else {
        return(
            <div>
                <ProjectDetail {...project} />
            </div>
        )
    }
}

export default ProjectDetailContainer